'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();

import { createContext, ReactNode, useContext } from 'react'

import { CanaryClient } from './client'

const CanaryClientContext = createContext<CanaryClient | null>(null)
export function useCanaryClient() {
  const canaryClient = useContext(CanaryClientContext)
  if (!canaryClient) {
    throw new Error(
      'useCanaryClient must be used within a CanaryClientProvider',
    )
  }
  return canaryClient
}

export function CanaryClientProvider({
  children,
  client,
}: {
  children: ReactNode
  client: CanaryClient
}) {
  return (
    <CanaryClientContext.Provider value={client}>
      {children}
    </CanaryClientContext.Provider>
  )
}
